
<div class="ui modal" id="SettingPasswordModalLogin" style="position:absolute;left:35%;bottom:15%">

  <div class="header" style="display:flex;">
    <div style="background-color:black;width:85%;color:white;"><span style="margin-left:10px">{{this._translate.getT("AttendantLogin")}}</span></div>
    <div style="background-color:black;width:15%;margin-left:10px">
      <button style="float:right;background-color:black;color:white;width:100%" class="ui icon button" (click)="SettingLogin_Close()">
        <i class="remove link icon"></i>
      </button>
    </div>
  </div>

  <div class="content">
    <div class="ui fluid input">
      <input placeholder="0" id="SettingLogin_Input" style="text-align:right;height:55px;font-size:40px;background-color:gainsboro" type="password" [(ngModel)]="this.SettingLogin_Input_Value">
    </div>
  </div>
  <div class="inline field" style="text-align: center;color:red;">


    <span *ngIf="this.tournamentsService.SettingPasswordErrorVisible==1">{{this._translate.getT("Password_is_incorrect")}}</span>

  </div>
  <div class="content">
    <div class="ui grid segment" style="height:412px;background-color:gainsboro;">
      <table class="ui table" id="SettingPasswordLogin_Modal_ButtonTable" style="background-color:gainsboro;">
        <tr>
          <td class="four wide">
            <button class="SettingLoginButton" (click)="SettingLogin_ChangeValue(1)">1</button>
          </td>
          <td class="four wide">
            <button class="SettingLoginButton" (click)="SettingLogin_ChangeValue(2)">2</button>
          </td>
          <td class="four wide">
            <button class="SettingLoginButton" (click)="SettingLogin_ChangeValue('3')">3</button>
          </td>
          <td rowspan="2" class="four wide">
            <button class="ui fluid icon button" style="height:170px;width:70px;background:black;color:white;" (click)="SettingLogin__Cancel()">
              <i class="big arrow left icon"></i>
            </button>
          </td>
        </tr>
        <tr>
          <td class="four wide">
            <button class="SettingLoginButton" (click)="SettingLogin_ChangeValue(4)">4</button>
          </td>
          <td class="four wide">
            <button class="SettingLoginButton" (click)="SettingLogin_ChangeValue(5)">5</button>
          </td>
          <td class="four wide">
            <button class="SettingLoginButton" (click)="SettingLogin_ChangeValue(6)">6</button>
          </td>
        </tr>
        <tr>
          <td class="four wide">
            <button class="SettingLoginButton" (click)="SettingLogin_ChangeValue(7)">7</button>
          </td>
          <td class="four wide">
            <button class="SettingLoginButton" (click)="SettingLogin_ChangeValue(8)">8</button>
          </td>
          <td class="four wide">
            <button class="SettingLoginButton" (click)="SettingLogin_ChangeValue(9)">9</button>
          </td>
          <td rowspan="2" class="four wide">
            <button class="ui fluid button" style="height:170px;width:70px;background:black;color:white;" (click)="SettingLogin_Ok()">
              OK
            </button>
          </td>
        </tr>
        <tr style="height:102px">
          <td></td>


        </tr>

      </table>
      <button class="SettingLoginButton" style="color:white;width:286px; height: 71px;position:relative;bottom: 103px;margin-left:10px;" (click)="SettingLogin_ChangeValue(0)">
        0
      </button>
    </div>
  </div>

</div>
<div class="ui modal " id="settingPassword_Modal" style="width:300px;text-align:center">
  <div class="ui inverted segment">

    <div class="ui inverted form" style="width:300px;">
      <div class="field">
        <span>{{this._translate.getT("Please_Enter_Password_for_Settings_Page")}}</span>
        <i class="cog icon" style="float:right"></i>


      </div>
      <div class="field">

        <input id="passwordInput" placeholder="Password" type="password" [(ngModel)]="this.tournamentsService.KeyboardValue">
      </div>


      <div class="inline field">


        <span *ngIf="this.tournamentsService.SettingPasswordErrorVisible==1">{{this.tournamentsService.settingPasswordError}}</span>

      </div>
      <div class="two field" style="text-align:center">
        <button class="ui button" (click)="PasswordControl()"><span>{{this._translate.getT("Ok")}}</span></button>
        <!--<button class="ui icon button" (click)="OpenTerminalKeyboardModal()" ><i class="keyboard icon"></i> </button>-->
      </div>

    </div>
  </div>
</div>
<div class="ui modal " id="settingTerminal_Modal" style="width:400px;height:200px;text-align:center">
  <div class="ui inverted segment">

    <div class="ui inverted form">
      <div class="field" style="text-align:center">
        <span>{{this._translate.getT("SETTINGS_PAGE")}}</span>
        <i class="cog icon"></i>

      </div>



      <div class="two field" style="text-align:center">
        <!--reset
        start // kart çıktığında-->

        <button class="ui positive fluid icon button settingTerminalButtons" (click)="MoneyReaderRestartButton()">
          <i class="money bill alternate icon"></i>
          <span>{{this._translate.getT("Money_Reader_Restart")}}</span>
        </button>

        <!--<button class="ui {{this.moneyReaderActive}} positive icon button settingTerminalButtons" (click)="MoneyActiveButton()">
            <i class="money bill alternate icon"></i>
            <span>{{this._translate.getT("Money_Reader_Active")}}</span>
        </button>


        <button class="ui {{this.moneyReaderPassive}} negative icon button settingTerminalButtons" (click)="MoneyReader_Stop_Button()">
            <i class="money bill alternate icon"></i>
            <span>{{this._translate.getT("Money_Reader_Stop")}}</span>
        </button>-->
      </div>
      <div class="two field" style="text-align:center">


        <button class="ui purple icon button settingTerminalButtons" (click)="CheckCashBoxDate()">
          <i class="closed captioning icon"></i>
          <span>{{this._translate.getT("CheckCashBox")}}({{this._translate.getT("Date")}})</span>
        </button>

        <button class="ui purple icon button settingTerminalButtons" (click)="CheckCashBox()">
          <i class="closed captioning icon"></i>
          <span>{{this._translate.getT("CheckCashBox")}}</span>
        </button>

      </div>
      <div class="two field" style="text-align:center">

        <button class="ui red icon button settingTerminalButtons" (click)="PrintLastSlipDetail()">
          <i class="print icon"></i>
          <span>{{this._translate.getT("LastPayout")}}</span>
        </button>

        <button class="ui grey icon button settingTerminalButtons" (click)="PrintLastPayout()">
          <i class="print icon"></i>
          <span>{{this._translate.getT("PayoutSlipPay")}}</span>
        </button>


      </div>

      <div class="two field" style="text-align:center">
        <button class="ui yellow icon button settingTerminalButtons" (click)="PrintLastSlip()">
          <i class="print icon"></i>
          <span>{{this._translate.getT("LastSlip")}}</span>
        </button>

        <button class="ui orange icon button settingTerminalButtons" (click)="SignOutTerminal()">
          <i class="sign out alternate icon"></i>
          <span>{{this._translate.getT("Sign_Out")}}</span>
        </button>


      </div>

    </div>
  </div>
</div>
<div class="ui modal" id="closeCashBoxModal" style="width:450px;height:450px;font-size:15px;position: absolute;left: 33%; top: 10%;">
  <div class="content" style="background-color:#dfe8f6">
    <span style="float:left;color:black;  font-size: 15px;position: relative; bottom: 8px; right: 18px;">{{this._translate.getT("CASHBOX_CLOSED")}}</span>

    <button class="circular ui icon button" style="float:right;background-color:#dfe8f6;border: 1px solid;position: relative;
    bottom: 19px;left:20px" (click)="ExitCashBoxModel()">
      <i class="remove link icon"></i>
    </button>
  </div>
  <table style="width:450px;font-size:15px;">
    <tr *ngFor="let cashbox of this.tournamentsService.closeCahBoxList">
      <td>{{cashbox.TransactionType}}</td>
      <td>{{cashbox.Amount}}</td>
    </tr>


  </table>
  <br>
  <table style="width:450px;background-color:#dfe8f6;font-size:15px;">
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Period")}}:</span></td>
      <td>{{this.tournamentsService.closeCahBoxList[0]?.Period}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("ReportNo")}}:</span></td>
      <td>{{this.tournamentsService.closeCahBoxList[0]?.ReportNo}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("CashBox_Balance")}}:</span></td>
      <td>{{this.tournamentsService.closeCahBoxList[0]?.Balance}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Affiliate")}}:</span></td>
      <td>{{this.tournamentsService.closeCashBoxBranch.Affiliate}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Affiliate_ID")}}:</span></td>
      <td>{{this.tournamentsService.closeCashBoxBranch.AffiliateID}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Cashier")}}:</span></td>
      <td>{{this.tournamentsService.closeCashBoxBranch.Cashier}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Cashier_ID")}}:</span></td>
      <td>{{this.tournamentsService.closeCashBoxBranch.CashierID}}</td>
    </tr>
    <tr>
      <td></td>
      <td></td>
    </tr>

  </table>
  <div class="two field" style="text-align:center;background-color:#dfe8f6;height:85px;">
    <button class="ui button terminalButton" style="position:relative; top:25px;" (click)="PrintCashBoxModel()"><span>Print</span></button>
    <button class="ui icon button terminalButton" style="position:relative; top:25px;" (click)="ExitCashBoxModel()"><span>Close</span> </button>
  </div>


</div>
<div class="ui modal" id="CheckCashBoxModal" style="width:450px;height:450px;font-size:15px;position: absolute;left: 33%; top: 10%;">
  <div class="content" style="background-color:#dfe8f6">
    <span style="float:left;color:black;  font-size: 15px;position: relative; bottom: 8px; right: 18px;">{{this._translate.getT("CheckCashBox")}}</span>

    <button class="circular ui icon button" style="float:right;background-color:#dfe8f6;border: 1px solid;position: relative;
    bottom: 19px;left:20px" (click)="ExitCheckCashBoxModel()">
      <i class="remove link icon"></i>
    </button>
  </div>
  <table style="width:450px;font-size:15px;">
    <tr *ngFor="let cashbox of this.tournamentsService.checkCashBoxList">
      <td>{{cashbox.TransactionType}}</td>
      <td>{{cashbox.Amount}}</td>
    </tr>


  </table>
  <br>
  <table style="width:450px;background-color:#dfe8f6;font-size:15px;">
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Period")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxBranch.Period}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("ReportNo")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxList[0]?.ReportNo}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("CashBox_Balance")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxList[0]?.Balance}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Affiliate")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxBranch.Affiliate}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Affiliate_ID")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxBranch.AffiliateID}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Cashier")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxBranch.Cashier}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Cashier_ID")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxBranch.CashierID}}</td>
    </tr>
    <tr>
      <td></td>
      <td></td>
    </tr>

  </table>
  <div class="two field" style="text-align:center;background-color:#dfe8f6;height:85px;">
    <button class="ui button terminalButton" style="position:relative; top:25px;" (click)="PrintCheckCashBoxModel()"><span>Print</span></button>
    <button class="ui icon button terminalButton" style="position:relative; top:25px;" (click)="ExitCheckCashBoxModel()"><span>Close</span> </button>
  </div>


</div>
<div class="ui modal " id="CashboxClosedYesNo" style="width:400px;height:130px;">



  <div class="content" style="background-color:#dfe8f6">
    <span style="float:left;color:black;  font-size: 15px;position: relative; bottom: 8px; right: 18px;">{{this._translate.getT("CASHBOX_CLOSED")}}</span>

    <button class="circular ui icon button" style="float:right;background-color:#dfe8f6;border: 1px solid;position: relative;
    bottom: 19px;left:20px" (click)="ExitCashBoxYesNo()">
      <i class="remove link icon"></i>
    </button>
  </div>
  <br />
  <div>
    <span style="font-weight:bold;font-size:15px;">{{this._translate.getT("Proceed")}}?</span>
  </div>
  <br />
  <div class="two field" style="text-align:center">
    <button class="ui primary button" (click)="CashBoxClosedYes()"><span>{{this._translate.getT("Yes")}}</span></button>
    <button class="ui primary button" (click)="CashBoxClosedNo()"><span>{{this._translate.getT("No")}}</span></button>

  </div>



</div>
<!--<div class="ui modal " id="CheckBoxSelectDate" style="width:400px;height:130px;">

  <div class="content" style="background-color:#dfe8f6">
    <span style="float:left;color:black;  font-size: 15px;position: relative; bottom: 8px; right: 18px;">CHECKBOX SELECT DATE</span>

    <button class="circular ui icon button" style="float:right;background-color:#dfe8f6;border: 1px solid;position: relative;
    bottom: 19px;left:20px" (click)="ExitCheckBoxSelectDate()">
      <i class="remove link icon"></i>
    </button>
  </div>
  <div class="content" style="text-align:center">

    <div>
      <div><span style="font-weight:bold">Start Date</span> </div>
      <div class="ui input left icon">
        <i class="calendar icon"></i>
        <input type="date" placeholder="Date/Time" required="required" id="CbStartDate">
      </div>
    </div>
    <br />
    <div>
      <div><span style="font-weight:bold">End Date</span>  </div>
      <div class="ui input left icon">
        <i class="calendar icon"></i>
        <input type="date" placeholder="Date/Time" required="required" id="CbEndDate">
      </div>
    </div>
  </div>
  <div class="content" style="color:red;text-align:center" *ngIf="this.DateErrorVisible==1">
    <span>{{this._translate.getT("errorcode1")}}</span>
  </div>
  <div class="content" style="text-align:center">
    <button class="ui primary button" (click)="SendCheckBoxDate()"><span>{{this._translate.getT("Ok")}}</span></button>

  </div>


</div>-->
<div class="ui modal" id="CheckCashBoxDateModal" style="width:450px;height:450px;font-size:15px;position: absolute;left: 33%; top: 10%;">
  <div class="content" style="background-color:#dfe8f6">
    <span style="float:left;color:black;  font-size: 15px;position: relative; bottom: 8px; right: 18px;">{{this._translate.getT("CheckCashBox")}}</span>

    <button class="circular ui icon button" style="float:right;background-color:#dfe8f6;border: 1px solid;position: relative;
    bottom: 19px;left:20px" (click)="ExitCheckCashBoxDateModal()">
      <i class="remove link icon"></i>
    </button>
  </div>
  <table style="width:450px;font-size:15px;">
    <tr *ngFor="let cashbox of this.tournamentsService.checkCashBoxList">
      <td>{{cashbox.TransactionType}}</td>
      <td>{{cashbox.Amount}}</td>
    </tr>


  </table>
  <br>
  <table style="width:450px;background-color:#dfe8f6;font-size:15px;">
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Period")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxList[0]?.Period}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("ReportNo")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxList[0]?.ReportNo}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("CashBox_Balance")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxList[0]?.Balance}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Affiliate")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxBranch.Affiliate}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Affiliate_ID")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxBranch.AffiliateID}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Cashier")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxBranch.Cashier}}</td>
    </tr>
    <tr>
      <td><span style="font-weight:bold">{{this._translate.getT("Cashier_ID")}}:</span></td>
      <td>{{this.tournamentsService.checkCashBoxBranch.CashierID}}</td>
    </tr>
    <tr>
      <td></td>
      <td></td>
    </tr>

  </table>
  <div class="two field" style="text-align:center;background-color:#dfe8f6;height:85px;">
    <button class="ui button terminalButton" style="position:relative; top:25px;" (click)="PrintCheckCashBoxDateModel()"><span>Print</span></button>
    <button class="ui icon button terminalButton" style="position:relative; top:25px;" (click)="ExitCheckCashBoxDateModal()"><span>Close</span> </button>
  </div>


</div>
<!--<comp_terminal_keyboard_modal (TerminalKeyBoardValue)="getTerminalKeyBoardValue($event);"></comp_terminal_keyboard_modal>-->
<comp_read_payout></comp_read_payout>
<comp_print_cashboxclosed></comp_print_cashboxclosed>
<comp_print_lastSlip></comp_print_lastSlip>
<comp_print_lastPayout></comp_print_lastPayout>

<iframe hidden style="width:274px" id="LastSlip_PrintArea_Iframe" name="LastSlip_PrintArea_Iframe"></iframe>
<iframe hidden style="width:274px" id="LastPayout_PrintArea_Iframe" name="LastPayout_PrintArea_Iframe"></iframe>
<style>
  .settingTerminalButtons {
    width: 176px;
    height: 50px;
    font-size: 12px;
  }
</style>


<!--NEW SETTINGS MODAL-->
<div class="ui large modal" id="settings_Modal_2">
  <!--<i class="close icon"></i>-->
  <div class="ui inverted grid" style="min-height:600px;">
    <div class="four wide column" style="background-color: #1b1c1d;padding: 8px;">

      <div class="ui vertical fluid tabular inverted menu" style="background-color:#1b1c1d;border:0">
        <a class="active item ui green basic inverted button" data-tab="tab-1">
          {{this._translate.getT("Money_Reader_Restart")}}
        </a>
        <a class="item ui blue basic inverted button" data-tab="tab-2" (click)="CheckCashBoxDate()">
          {{this._translate.getT("CheckCashBox_Date")}}
        </a>
        <a class="item ui orange basic inverted button" data-tab="tab-3" (click)="CheckCashBox()">
          {{this._translate.getT("Settings_CheckCashBox")}}
        </a>
        <a class="item ui purple basic inverted button" data-tab="tab-4">
          {{this._translate.getT("Settings_Last_Payout")}}
        </a>
        <a class="item ui yellow basic inverted button" data-tab="tab-5">
          {{this._translate.getT("Settings_Last_Slip")}}
        </a>
        <a class="item ui grey basic inverted button" data-tab="tab-6">
          {{this._translate.getT("Settings_Pay")}}
        </a>
        <a class="item ui grey basic inverted button" data-tab="tab-8">
          {{this._translate.getT("Settings")}}
        </a>
        <a class="item ui red basic inverted button" data-tab="tab-7" (click)="Exit_Settings_Modal()">
          {{this._translate.getT("Settings_Exit")}}
        </a>
      </div>
    </div>
    <div class="twelve wide stretched column" style="padding:0">
      <!--TAB - 1 -->
      <div class="ui tab active inverted segment" data-tab="tab-1">
        <button class="ui positive fluid icon button settingTerminalButtons" (click)="MoneyReaderRestartButton()">
          <i class="money bill alternate icon"></i>
          <span>{{this._translate.getT("Money_Reader_Restart")}}</span>
        </button>
      </div>
      <!--TAB - 1 -->

      <!--TAB - 2 -->
      <div class="ui tab inverted segment" data-tab="tab-2">

        <div style="width:40%;float:left">

          <div style="font-size: 22px;color: white;width: 100% !important;text-align: center;padding-bottom: 10px;">
            {{this._translate.getT("Checkbox_Select_Date")}}
          </div>
          <div class="content" style="text-align:center">

            <div>
              <div><span style="font-weight:bold">{{this._translate.getT("Please_Select_Start_Date")}}</span> </div>
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input type="date" placeholder="Date/Time" required="required" id="CbStartDate">
              </div>
            </div>
            <br />
            <div>
              <div><span style="font-weight:bold">{{this._translate.getT("Please_Select_Finish_Date")}}</span> </div>
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input type="date" placeholder="Date/Time" required="required" id="CbEndDate">
              </div>
            </div>
          </div>
          <div class="content" style="color:red;text-align:center" *ngIf="this.DateErrorVisible==1">
            <span>{{this._translate.getT("errorcode1")}}</span>
          </div>
          <div class="content" style="text-align:center">
            <button class="ui primary button" (click)="SendCheckBoxDate()"><span>{{this._translate.getT("Ok")}}</span></button>

          </div>
        </div>

        <div style="width:60%;float:right;color:black" *ngIf="this.tournamentsService.checkCashBoxList.length > 0">


          <div style="font-size: 22px;color: white;width: 100% !important;text-align: center;padding-bottom: 10px;">
           {{this._translate.getT("CheckCashBox")}}
          </div>
          <table style="width:100%;font-size:15px;background-color:white">
            <tr *ngFor="let cashbox of this.tournamentsService.checkCashBoxList">
              <td>{{cashbox.TransactionType}}</td>
              <td>{{cashbox.Amount}}</td>
            </tr>


          </table>
          <table style="width:100%;background-color:#dfe8f6;font-size:15px;">
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("Period")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxList[0]?.Period}}</td>
            </tr>
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("ReportNo")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxList[0]?.ReportNo}}</td>
            </tr>
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("CashBox_Balance")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxList[0]?.Balance}}</td>
            </tr>
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("Affiliate")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxBranch.Affiliate}}</td>
            </tr>
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("Affiliate_ID")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxBranch.AffiliateID}}</td>
            </tr>
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("Cashier")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxBranch.Cashier}}</td>
            </tr>
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("Cashier_ID")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxBranch.CashierID}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
            </tr>

          </table>
          <div class="two field" style="text-align:center;background-color:#dfe8f6;height:85px;">
            <button class="ui button terminalButton" style="position:relative; top:25px;" (click)="PrintCheckCashBoxDateModel()"><span>{{this._translate.getT("Print")}}</span></button>
            <!--<button class="ui icon button terminalButton" style="position:relative; top:25px;" (click)="ExitCheckCashBoxDateModal()"><span>Close</span> </button>-->
          </div>



        </div>


      </div>
      <!--TAB - 2 -->

      <!--TAB - 3 -->
      <div class="ui tab inverted segment" data-tab="tab-3">

        <div style="width: 450px;font-size: 15px;color: black;left: 25%;position: inherit;">
          <div style="font-size: 22px;color: white;width: 100% !important;text-align: center;padding-bottom: 10px;">
            {{this._translate.getT("CheckCashBox")}}
          </div>

          <table style="width:450px;font-size:15px;background-color:white">
            <tr *ngFor="let cashbox of this.tournamentsService.checkCashBoxList">
              <td>{{cashbox.TransactionType}}</td>
              <td>{{cashbox.Amount}}</td>
            </tr>


          </table>
          <table style="width:450px;background-color:#dfe8f6;font-size:15px;">
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("Period")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxBranch.Period}}</td>
            </tr>
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("ReportNo")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxList[0]?.ReportNo}}</td>
            </tr>
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("CashBox_Balance")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxList[0]?.Balance}}</td>
            </tr>
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("Affiliate")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxBranch.Affiliate}}</td>
            </tr>
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("Affiliate_ID")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxBranch.AffiliateID}}</td>
            </tr>
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("Cashier")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxBranch.Cashier}}</td>
            </tr>
            <tr>
              <td><span style="font-weight:bold">{{this._translate.getT("Cashier_ID")}}:</span></td>
              <td>{{this.tournamentsService.checkCashBoxBranch.CashierID}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
            </tr>

          </table>
          <div class="two field" style="text-align:center;background-color:#dfe8f6;height:85px;">
            <button class="ui button terminalButton" style="position:relative; top:25px;" (click)="PrintCheckCashBoxModel()"><span>{{this._translate.getT("Print")}}</span></button>
            <!--<button class="ui icon button terminalButton" style="position:relative; top:25px;" (click)="ExitCheckCashBoxModel()"><span>Close</span> </button>-->
          </div>
        </div>




      </div>
      <!--TAB - 3 -->

      <!--TAB - 4 -->
      <div class="ui tab inverted segment" data-tab="tab-4">

        <button class="ui purple icon fluid button settingTerminalButtons" (click)="PrintLastSlipDetail()">
          <i class="print icon"></i>
          <span>{{this._translate.getT("LastPayout")}}</span>
        </button>


      </div>
      <!--TAB - 4 -->

      <!--TAB - 5 -->
      <div class="ui tab inverted segment" data-tab="tab-5">

        <button class="ui yellow icon fluid button settingTerminalButtons" (click)="PrintLastSlip()">
          <i class="print icon"></i>
          <span>{{this._translate.getT("LastSlip")}}</span>
        </button>

      </div>
      <!--TAB - 5 -->

      <!--TAB - 6 -->
      <div class="ui tab inverted segment" data-tab="tab-6">

        <button class="ui grey icon fluid button settingTerminalButtons" (click)="PrintLastPayout()">
          <i class="print icon"></i>
          <span>{{this._translate.getT("PayoutSlipPay")}}</span>
        </button>

      </div>
      <!--TAB - 6 -->

      <!--TAB - 8 -->
      <div class="ui tab inverted segment" data-tab="tab-8">

        <div class="ui toggle checkbox" id="IsAnonymousBet_CheckBox">
          <input type="checkbox" name="public" [checked]="this.coreService.customerUser.IsAnonymousBet == 1">
          <label style="color:white !important">{{"anonymousbet" | t}}: {{this.coreService.customerUser.IsAnonymousBet == 0 ?
            false : true}}</label>
        </div>

        <!-- TEST için Eklendi sonra silinecek-->
<!--        <div style="margin-top: 10px">-->
<!--          <button class="ui grey icon fluid button settingTerminalButtons" (click)="RunMoney()">-->
<!--            runmoneyreader-->
<!--          </button>-->
<!--        </div>-->
<!--        <div style="margin-top: 10px">-->
<!--          <button class="ui grey icon fluid button settingTerminalButtons" (click)="HaltMoney()">-->
<!--            haltmoneyreader-->
<!--          </button>-->
<!--        </div>-->

<!--        <div style="margin-top: 10px">-->
<!--          <button class="ui grey icon fluid button settingTerminalButtons" (click)="RestartMoney()">-->
<!--            restartmoneyreader-->
<!--          </button>-->
<!--        </div>-->

<!--        <div style="margin-top: 10px">-->
<!--          <button class="ui grey icon fluid button settingTerminalButtons" (click)="HaltMoney2()">-->
<!--            haltmoneyreader2-->
<!--          </button>-->
<!--        </div>-->

      </div>
      <!--TAB - 8 -->

      <!--TAB - 7 -->
      <div class="ui tab inverted segment" data-tab="tab-7">

      </div>
      <!--TAB - 7 -->

     </div>
  </div>
</div>
<!--NEW SETTINGS MODAL-->

<style>
  .ui.tab.segment {
    margin: 0;
  }
</style>
